import type { AxiosResponse } from 'axios'
import type { NotificationStatusType } from '@/enum/NotificationStatusType'
import type { IApiResponse } from '@/interfaces/IApiResponse'
import type { INotificationStatus } from '@/interfaces/INotificationStatus'
import useAxios from '@/composable/useAxios'

export const notificationStatusApi = {
    read: async (type: NotificationStatusType): Promise<void> => {
        await useAxios.delete(`/notification-status/type/${type}/read`)
    },
    get: async (): Promise<INotificationStatus> => {
        const response: AxiosResponse<IApiResponse<INotificationStatus>> = await useAxios.get(`/notification-status`)
        return response.data.data
    },
}
